import { useNavigate } from "react-router-dom";

import { useTranslation } from "@/core/i18n";
import { Button } from "@/components/ui/button";
import { Models } from "api/types";
import AddedToCartCheck from "atoms/icon/icons/ic_added_to_cart_check_ol.svg";
import { ActionModal } from "molecules/modal-window/action-modal/ActionModal";
import { formatCurrency } from "toolbox/Money";

type AddedToCartModalProps = {
  title: string | null | undefined;
  subtitle: string;
  cost: number;
  open: boolean;
  membership: Models<"MembershipModel"> | null | undefined;
  onClose: () => void;
  giftCard?: {
    label: string;
    onGiftCardClick: () => void;
  };
  firstButtonLink?: string;
};

export const AddedToCartModal = ({
  firstButtonLink = "/cart",
  ...props
}: AddedToCartModalProps) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <ActionModal
      open={props.open}
      onClose={props.onClose}
      size="small"
      firstButtonLabel={t("addedToCartModal.viewCart")}
      onFirstButtonClick={() => navigate(firstButtonLink)}
      headerIconSvg={AddedToCartCheck}
      title={t("addedToCartModal.title")}
      useAnimatedBackground={true}
      description={
        <div className="flex flex-col justify-center text-center">
          <div className="flex justify-between gap-2 px-2 pt-4">
            <div className="flex flex-col gap-1.5">
              <div className="text-left text-body1 text-primary">{props.title}</div>
              <div className="text-left text-body2 text-secondary">{props.subtitle}</div>
            </div>
            <div>
              <div className="text-body1 text-primary">{formatCurrency(props.cost)}</div>
            </div>
          </div>
          {props.membership && (
            <div className="flex justify-between gap-2 py-2">
              <div className="flex flex-col text-left">
                <div className="text-left text-body1 text-primary">{props.membership.name}</div>
                <div className="text-left text-body2 text-secondary">
                  {t("addedToCartModal.membership")}
                </div>
              </div>
              <div className="text-body1 text-primary">
                {formatCurrency(props.membership.monthlyCost)}
              </div>
            </div>
          )}
          {!!props.giftCard && (
            <Button
              type="button"
              size="lg"
              className="mt-3 border border-brand-color bg-brand-color/10 text-brand-color hover:bg-brand-color/20"
              onClick={props.giftCard.onGiftCardClick}
            >
              {props.giftCard.label}
            </Button>
          )}
        </div>
      }
    />
  );
};
